import React from 'react';
import styled, { css } from 'styled-components';

const ButtonVariants = {
  primary: css`
    background-color: var(--primary);
    color: var(--white);
    border: none;
    
    &:hover {
      background-color: var(--primary-dark);
    }
  `,
  secondary: css`
    background-color: transparent;
    color: var(--primary);
    border: 2px solid var(--primary);
    
    &:hover {
      background-color: var(--light-bg);
    }
  `,
  tertiary: css`
    background-color: transparent;
    color: var(--primary);
    border: none;
    padding: var(--spacing-sm) var(--spacing-md);
    
    &:hover {
      color: var(--primary-dark);
      text-decoration: underline;
    }
  `
};

const ButtonSizes = {
  small: css`
    padding: var(--spacing-xs) var(--spacing-md);
    font-size: var(--font-size-sm);
  `,
  medium: css`
    padding: var(--spacing-sm) var(--spacing-lg);
    font-size: var(--font-size-md);
  `,
  large: css`
    padding: var(--spacing-md) var(--spacing-xl);
    font-size: var(--font-size-lg);
  `
};

const StyledButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  border-radius: var(--border-radius-md);
  transition: all var(--transition-fast);
  cursor: pointer;
  
  ${props => ButtonVariants[props.variant]}
  ${props => ButtonSizes[props.size]}
  
  ${props => props.fullWidth && css`
    width: 100%;
  `}
  
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
  
  svg {
    margin-right: ${props => props.iconPosition === 'left' ? 'var(--spacing-sm)' : '0'};
    margin-left: ${props => props.iconPosition === 'right' ? 'var(--spacing-sm)' : '0'};
  }
`;

const Button = ({
  children,
  variant = 'primary',
  size = 'medium',
  type = 'button',
  fullWidth = false,
  disabled = false,
  icon = null,
  iconPosition = 'left',
  onClick,
  ...props
}) => {
  return (
    <StyledButton
      type={type}
      variant={variant}
      size={size}
      fullWidth={fullWidth}
      disabled={disabled}
      iconPosition={iconPosition}
      onClick={onClick}
      {...props}
    >
      {icon && iconPosition === 'left' && icon}
      {children}
      {icon && iconPosition === 'right' && icon}
    </StyledButton>
  );
};

export default Button;
